import { createContext } from 'react';

const MatrixContext = createContext();

export default MatrixContext;
